import { useState, useEffect } from 'react'
import {
    Box, Center
  } from '@chakra-ui/react';
import List from './list'
import {getTokenId} from '../lib/nftList'
import BuyNFT from './buynft'
import { useWeb3React } from "@web3-react/core"
import nfts from '../lib/nfts'
import OwnerPage from './adminpage'
import AdminSendPage from './adminSendPage'
import SendNFT from './sendNFT'
import MyYieldTokens from './myYieldTokens'
import {toBN} from '../lib/bn'

const Main = (props) => {
    const {active, account, library} = useWeb3React()
    let [page, setPage] = useState('myYieldTokens') //useState('nftList')
    let [tokenIdToBuy, setTokenId] = useState(null)
    let [meta, setMeta] = useState(null)
    let [usdc, setUSDC] = useState(null)
    let [allowance, setAllowance] = useState(null)
    let [isOwner, setIsOwner] = useState(false)
    let [isAdmin, setIsAdmin] = useState(false)
    let [hasAccessToken, setHasAccessToken] = useState(-1)
    let [yieldTokens, setYieldTokens] = useState(null)


    const buyNFT = (meta) => {
        setMeta(meta)
        setPage('buyNFT')
        getTokenId(meta.url).then(tokenId=>{
            console.log('tokenID: ' + tokenId)
            setTokenId(tokenId)
        })
        
    }

    /*
    const setAdmin = (isadmin) => {
        props.setIsAdmin(isadmin)
        setIsAdmin(isadmin)
        if(!isadmin)setPage('nftList')
    }
    */

    const updateAllowance = async () => {
        let amnt = await nfts.USDC.allowance(account,nfts.yieldSale.address)
        setAllowance(amnt)
    }

    useEffect(()=>{
        if(account){
            //nfts.USDC.balanceOf(account).then(amnt=>setUSDC(amnt))
            //updateAllowance().then()
            nfts.yieldToken.owner().then(owner=>{
                console.log('setting is owner')
                setIsOwner(account===owner)
                //setAdmin(account===owner)
                if(account===owner){
                    props.setIsAdmin(true)
                    setIsAdmin(true)
                }
            })
            nfts.accessToken.balanceOf(account).then(bal=>{
                console.log('has Access token: ' + bal)
                if(bal.gt(toBN(0))){
                    setHasAccessToken(1)
                } else {
                    setHasAccessToken(0)
                }
            })
            getYieldTokens().then(tokenIds=>setYieldTokens(tokenIds))
        }
        /*
        if(account && props.showYieldTokens && page!=='myYieldTokens'){
            getYieldTokens().then(tokenIds=>setYieldTokens(tokenIds))
            setPage('myYieldTokens')
        } else if (account && page==='myYieldTokens' && !props.showYieldTokens){
            setPage('nftList')
        }
        */
    },[account]) //, props.showYieldTokens])

    const getYield = async (tokenId) => {
        try{
            return await nfts.yieldToken.yieldBalance(library.getSigner(account), tokenId)
        } catch(e){
            console.log(e)
            return toBN(0)
        }
    }

    const getYieldTokens = async () => {
        console.log('getting yield tokens')
       let numYieldTokens = await nfts.yieldToken.balanceOf(account)
       if(numYieldTokens===0)return []       
       let idx = []
       for(let i=0;i<numYieldTokens;i++){
           idx.push(i)
       }
       let tokens = await Promise.all(idx.map(async idx =>{
           let tokenId = await nfts.yieldToken.tokenOfOwnerByIndex(account,idx)
           let ar = [
                async ()=> await nfts.yieldToken.tokenURI(tokenId),
                async ()=> await getYield(tokenId)
            ]
            let data = await Promise.all(ar.map(async itm => await itm()))
            let uri = data[0]
            let yieldBal = data[1]
            return {tokenId,uri,yield:yieldBal}
       }))
       
       return tokens
    }

    const updateYield = async (tokenId) => {
        let tokens = await getYieldTokens()
        setYieldTokens(tokens)
    }

    const nftList = () => {
        setTokenId(null)
        setPage('nftList')
    }

    const purchaseDone = () => {
        setTokenId(null)
        getTokenId(meta.url).then(tokenId=>{
            console.log('tokenID: ' + tokenId)
            setTokenId(tokenId)
        })
    }

    console.log('show yield tokens: ' + props.showYieldTokens)
    console.log('Page ' + page)
    //<OwnerPage isOwner={isOwner} isAdmin={isAdmin}/>
    return (<Center>
        {props.adminOpen && 
            <AdminSendPage/>
        }
        {page==='myYieldTokens' && !props.adminOpen && <MyYieldTokens yieldTokens={yieldTokens} hasAccessToken={hasAccessToken} updateYield={updateYield}/>}
        {page==='nftList' && !props.adminOpen && <List onClick={buyNFT}/>}
        {page==='buyNFT' && !props.adminOpen && <BuyNFT tokenId={tokenIdToBuy} hasAccessToken={hasAccessToken} meta={meta} back={nftList} usdc={usdc} allowance={allowance} updateAllowance={updateAllowance} done={purchaseDone}/>}
    </Center>)
}

export default Main